import { CbhFeatureFlag, FEATURE_FLAG_DEFAULT_VALUES, useCbhFlag } from "@src/appV2/FeatureFlags";

/**
 * Wrapper hook for the DELAYED_WORKPLACE_REVIEW feature flag.
 * Centralizes the default value configuration in one place.
 */
export function useDelayedWorkplaceReviewFlag() {
  return useCbhFlag(CbhFeatureFlag.DELAYED_WORKPLACE_REVIEW, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.DELAYED_WORKPLACE_REVIEW],
  });
}
